import { CoursesService } from '@/services/courses.service'

export default {
  getList ({ commit }) {
    return CoursesService.list()
      .then(data => {
        commit('SET_COURSE_LIST', data)
      })
  }
}
